import React from 'react';
import classnames from 'classnames';
import { IconX } from '@pentabd/icons';
import { createPortal } from 'react-dom';

export interface ModalProps {
  children?: string | JSX.Element | JSX.Element[];
  isOpen?: boolean;
  closeAble?: boolean;
  onClose?: (e) => void;
  overlay?: boolean;
  portal?: boolean;
}

const Modal = ({
  isOpen = false,
  children,
  onClose,
  closeAble,
  overlay,
  portal,
}: ModalProps) => {
  const FinalModal = (
    <div className="d-flex justify-content-center scrollbar">
      {overlay && (
        <div
          className={classnames(
            `modal-overlay vw-100 vh-100 position-fixed top-0 left-0`,
            {
              'd-block': isOpen,
              'd-none': !isOpen,
            },
          )}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onClick={closeAble ? onClose : () => {}}
        />
      )}
      <div
        className={classnames('modal', 'shadow-lg', 'position-fixed', {
          'modal-open': isOpen,
          'modal-close': !isOpen,
        })}
      >
        <div className="position-absolute right-0 m-4 pointer z-5">
          <IconX size="24" onClick={onClose} />
        </div>
        {children}
      </div>
    </div>
  );

  if (portal) {
    return createPortal(FinalModal, document.body);
  }

  return FinalModal;
};

export default Modal;
